import { verifyGiftCard } from './verify-gift-card';
import { redeemGiftCard } from './redeem-gift-card';

import { fetchBanks } from './fetch-banks';

export const paymentsSDK = {
    giftCards: {
        verify: verifyGiftCard,
        redeem: redeemGiftCard,
    },

    fetchBanks: fetchBanks,
};
